import {Component, h} from 'preact'
import styles from "./style.module.scss"
import ProductImage from "../product-image";
import {Image} from "../../models/product";
import {icons} from "../icons";
import {connect} from "redux-zero/preact";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import { i18nService } from '../../services/i18n-service';
import { productService } from '../../services/product-service';

interface Props {
  image?: Image;
  onClickCallback?: () => void
  onEscapeCallback?: () => void
  isMobile: boolean;
  imageAlt: string;
}

class ImagePreview extends Component<Props, any> {

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPressed = this.handleKeyPressed.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleKeyPressed);
    document.body.style.overflow =  'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyPressed);
    document.body.style.overflow =  'visible';
    document.documentElement.style.overflow = 'visible';
  }

  handleClick() {
    if (this.props && this.props.onClickCallback) {
      this.props.onClickCallback();
    }
  }

  handleKeyPressed(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      if (this.props && this.props.onEscapeCallback) {
        this.props.onEscapeCallback();
      }
    }
  }

  render(props: Readonly<Props>) {
    if (this.props.isMobile) {
      return (
        <div class={styles['preview-container']}>
          <ProductImage image={props.image} alt={props.imageAlt} title={props.imageAlt} resolution={props.image?.type === 'CUTOUT' ? 'high' : 'higher'}/>
          <div onClick={this.handleClick} class={styles['arrow-container']}>
            {icons.renderCloseIcon()}
          </div>
        </div>
      );
    }

    if (!this.props.isMobile) {
      return (
        <div onClick={this.handleClick} class={styles['preview-container']}>
          <div class={styles['image-container']}>
            <ProductImage image={props.image}alt={props.imageAlt} title={props.imageAlt} resolution={"full-hd"} />
            <div onClick={this.handleClick} class={styles['arrow-container']}>
              {icons.renderCloseIcon()}
            </div>
          </div>
        </div>
      );
    }
  }
}
export default connect(null, null)(withDeviceIndicator(ImagePreview));